import * as yup from 'yup'

export const slugify = value =>
    (value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')

export const defaultSlug = (name, parentSlug) => slugify(parentSlug ? `${parentSlug} ${name}` : name)

export const EMPTY_CATEGORY = {
    name: '',
    slug: '',
    parent: '',
    position: 0,
    image: '',
    active: true,
    needsReview: false,
    reviewNote: '',
}

export const categorySchema = yup.object().shape({
    name: yup.string().required('Enter the category name.'),
    slug: yup
        .string()
        .required('Enter the slug used in the web address of the category.')
        .matches(
            /^[a-z0-9]+(-[a-z0-9]+)*$/,
            'Use lower-case letters, numbers and single hyphens only, e.g. lighting-headlights.'
        ),
    position: yup
        .number()
        .typeError('Enter a whole number.')
        .integer('Enter a whole number.')
        .min(0, 'Enter 0 or more.'),
})

const blankToNull = value => (typeof value === 'string' && value.trim() === '' ? null : value)

export const categoryForApi = values => ({
    name: values.name.trim(),
    slug: values.slug.trim(),
    parent: blankToNull(values.parent),
    position: parseInt(values.position, 10) || 0,
    image: blankToNull(values.image),
    active: !!values.active,
    needsReview: !!values.needsReview,
    reviewNote: blankToNull(values.reviewNote),
})

export const categoryForForm = category => ({
    ...EMPTY_CATEGORY,
    ...category,
    parent: category.parent ? category.parent['@id'] || category.parent : '',
    image: category.image || '',
    reviewNote: category.reviewNote || '',
})

export const FITTING_POSITION = 100

export const parseCriteriaValues = text =>
    (text || '')
        .split(',')
        .map(value => value.trim())
        .filter(value => value !== '')

export const linkLimit = link =>
    link.criteriaId
        ? `${link.criteriaId === FITTING_POSITION ? 'Fitting position' : `Criterion ${link.criteriaId}`}: ${(
              link.criteriaValues || []
          ).join(', ')}`
        : 'All parts'

export const linkSource = link =>
    link.sourceNodeId ? `${link.sourceNodeName || 'Node'} (${link.sourceNodeId})` : 'Added by hand'

export const linkForApi = link => ({
    category: link.category && (link.category['@id'] || link.category),
    genericArticleId: link.genericArticleId,
    genericArticleName: link.genericArticleName || null,
    criteriaId: link.criteriaId || null,
    criteriaValues: link.criteriaValues || [],
    sourceNodeId: link.sourceNodeId || null,
    sourceNodeName: link.sourceNodeName || null,
    needsReview: !!link.needsReview,
    reviewNote: link.reviewNote || null,
})
